<template>
    <div class="modal fade" id="createFormToEventEditModal" role="dialog" aria-labelledby="createFormToEventEditModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-xl" role="document">
            <div class="modal-content">
                <div class="modal-header mt-3 mb-0">
                    <h5 class="modal-title" id="createFormToEventEditModalLabel">{{$t('registers.forms.formToEvent.create')}}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="loader" v-if="isSaving"></div>
                <div v-else class="modal-body" :id="conatinerId">
                    <div class="card border-primary mb-3">
                        <h5 class="card-header text-primary">
                            <i class="fas fa-calendar-week mr-2"></i>
                            {{model.name}}
                        </h5>
                        <div class="card-body">
                            <!--{{isParticipationRequestForm}}-->
                            <!--{{model}}-->
                            <!--{{eventDetails}}-->

                            <div class="form-group">
                                <label class="font-weight-bold">
                                    {{$t('registers.forms.gridHeaders.eventName')}}
                                </label>

                                <input class="form-control" type="text" :value="eventDetails.eventName" readonly>
                            </div>

                            <div class="form-row">
                                <div class="form-group col-sm-12 col-md-6">
                                    <label class="font-weight-bold" :for="'eventStartDate' + _uid">
                                        {{$t('registers.events.gridHeaders.eventStartDate')}}
                                    </label>
                                    <div class="ml-2"
                                         :name="'eventStartDate' + _uid"
                                         :id="'eventStartDate' + _uid"
                                         aria-describedby="eventStartDateHelp">
                                        <span>{{eventDetails.eventStartDate ? $moment(eventDetails.eventStartDate).format('DD.MM.YYYY HH:mm') : ''}}</span>
                                    </div>
                                    <small id="eventStartDateHelp" class="form-text text-muted">{{ $t('registers.events.help.eventStartDate') }}</small>
                                </div>

                                <div class="form-group col-sm-12 col-md-6">
                                    <label class="font-weight-bold" :for="'eventEndDate' + _uid">
                                        {{ $t('registers.events.gridHeaders.eventEndDate') }}
                                    </label>
                                    <div class="ml-2"
                                         :name="'eventEndDate' + _uid"
                                         :id="'eventEndDate' + _uid"
                                         aria-describedby="eventEndDateHelp">
                                        <span>{{eventDetails.eventEndDate ? $moment(eventDetails.eventEndDate).format('DD.MM.YYYY HH:mm') : ''}}</span>
                                    </div>
                                    <small id="eventEndDateHelp" class="form-text text-muted">{{ $t('registers.events.help.eventEndDate') }}</small>
                                </div>
                            </div>

                            <div class="form-row">
                                <div class="form-group col-sm-12 col-md-6">
                                    <label class="font-weight-bold" :for="'eventSubscriptionStartDate' + _uid">
                                        {{$t('registers.events.gridHeaders.eventSubscriptionStartDate')}}
                                    </label>
                                    <div class="ml-2"
                                         :name="'eventSubscriptionStartDate' + _uid"
                                         :id="'eventSubscriptionStartDate' + _uid"
                                         aria-describedby="eventSubscriptionStartDateHelp">
                                        <span>{{eventDetails.eventSubscriptionStartDate ? $moment(eventDetails.eventSubscriptionStartDate).format('DD.MM.YYYY HH:mm') : ''}}</span>
                                    </div>
                                    <small id="eventSubscriptionStartDateHelp" class="form-text text-muted">{{ $t('registers.events.help.eventSubscriptionStartDate') }}</small>
                                </div>

                                <div class="form-group col-sm-12 col-md-6">
                                    <label class="font-weight-bold" :for="'eventSubscriptionEndDate' + _uid">
                                        {{ $t('registers.events.gridHeaders.eventSubscriptionEndDate') }}
                                    </label>
                                    <div class="ml-2"
                                         :name="'eventSubscriptionEndDate' + _uid"
                                         :id="'eventSubscriptionEndDate' + _uid"
                                         aria-describedby="eventSubscriptionEndDateHelp">
                                        <span>{{eventDetails.eventSubscriptionEndDate ? $moment(eventDetails.eventSubscriptionEndDate).format('DD.MM.YYYY HH:mm') : ''}}</span>
                                    </div>
                                    <small id="eventSubscriptionEndDateHelp" class="form-text text-muted">{{ $t('registers.events.help.eventSubscriptionEndDate') }}</small>

                                </div>
                            </div>

                            <hr />

                            <div class="alert alert-info alert-dismissible fade show" role="alert">
                                {{ $t('registers.forms.help.add')}}
                                <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>

                            <div class="form-group">
                                <label class="font-weight-bold required" :for="'firstName' + _uid">
                                    {{$t('registers.forms.templates')}}
                                </label>

                                <kendo-datasource ref="formTemplates"
                                                  :transport="templatesTransportSettings"
                                                  :server-filtering="false"
                                                  :server-paging="false"
                                                  :schema-model-id="'id'"
                                                  :schema-model-fields="templatesFields"
                                                  :schema-data="'items'"
                                                  :error="dataSourceError">
                                </kendo-datasource>

                                <kendo-multicolumncombobox :data-source-ref="'formTemplates'"
                                                           :data-text-field="'name'"
                                                           :data-value-field="'id'"
                                                           :name="'form-template' + _uid"
                                                           :id="'form-template' + _uid"
                                                           v-model="model.formId"
                                                           v-validate="'required'"
                                                           :data-vv-as="$t('registers.forms.templatesCopies')"
                                                           :clear-button="true"
                                                           :placeholder="$t('registers.forms.choose')"
                                                           :no-data-template="$t('missingData')"
                                                           :footer-template="footerTemplate"
                                                           :filter="'contains'"
                                                           :popup="popup"
                                                           :height="dropdownHeight"
                                                           class="form-control"
                                                           @select="formTemplateSelected"
                                                           aria-describedby="formHelp">
                                    <kendo-multicolumncombobox-column :field="'name'"
                                                                      :title="$t('registers.forms.gridHeaders.name')">
                                    </kendo-multicolumncombobox-column>
                                    <kendo-multicolumncombobox-column :field="'formType'"
                                                                      :title="$t('registers.forms.gridHeaders.formType')">
                                    </kendo-multicolumncombobox-column>
                                    <kendo-multicolumncombobox-column :field="'note'"
                                                                      :title="$t('registers.forms.gridHeaders.note')">
                                    </kendo-multicolumncombobox-column>
                                </kendo-multicolumncombobox>
                                <span class="text-danger" v-if="errors.has('form-template' + _uid)">{{ errors.first('form-template' + _uid) }}</span>
                                <small id="formHelp" class="form-text text-muted">{{ isEnVersion ? formTypeEn : formType }}</small>
                            </div>

                            <div class="form-group">
                                <label class="font-weight-bold" :class="eventDetails.appEventSettings.createNewFormOnAddToEvent === true ? 'required' : ''">
                                    {{$t('registers.forms.gridHeaders.formName')}}
                                </label>

                                <div v-if="eventDetails.appEventSettings.createNewFormOnAddToEvent === true">
                                    <input :name="'formToEventName' + _uid"
                                           :id="'formToEventName' + _uid"
                                           :data-vv-as="$t('registers.forms.gridHeaders.formName')"
                                           v-validate="'required'"
                                           class="form-control" type="text" v-model="model.name"
                                           aria-describedby="formNameHelp">
                                    <small id="formNameHelp" class="form-text text-muted">{{$t("registers.forms.formToEvent.help.formName")}}</small>
                                    <span class="text-danger" v-if="errors.has('formToEventName' + _uid)">{{ errors.first('formToEventName' + _uid) }}</span>
                                </div>
                                <div v-else>
                                    <input class="form-control" type="text" :value="model.name"
                                           aria-describedby="isTemplateToNameHelp"
                                           readonly>
                                    <small id="isTemplateToNameHelp" class="form-text text-muted">{{ $t('registers.forms.formToEvent.help.isTemplateToNameHelp') }}</small>
                                </div>
                            </div>

                            <div class="form-group">
                                <label class="font-weight-bold">
                                    {{$t('registers.forms.gridHeaders.formNameEn')}}
                                </label>

                                <div v-if="eventDetails.appEventSettings.createNewFormOnAddToEvent === true">
                                    <input :name="'formToEventNameEn' + _uid"
                                           :id="'formToEventNameEn' + _uid"
                                           class="form-control" type="text" v-model="model.nameEn">
                                </div>
                                <div v-else>
                                    <input class="form-control" type="text" :value="model.nameEn"
                                           aria-describedby="isTemplateToNameHelp"
                                           readonly>
                                    <small id="isTemplateToNameHelp" class="form-text text-muted">{{ $t('registers.forms.formToEvent.help.isTemplateToNameHelp') }}</small>
                                </div>
                            </div>


                            <div class="form-row">
                                <div class="form-group col-sm-12 col-md-6" v-if="formAnonymousFillingAllowed">
                                    <label class="font-weight-bold">
                                        {{$t('registers.forms.gridHeaders.isAnonymous')}}
                                    </label>
                                    <toggled-btn v-model="model.isAnonymous"
                                        :sync="true"
                                        :name="'isAnonymous'">
                                    </toggled-btn>
                                </div>

                                <div class="form-group col-sm-12 col-md-6">
                                    <label class="font-weight-bold">
                                        {{$t('registers.forms.gridHeaders.isAuthorHidden')}}
                                    </label>
                                    <toggled-btn v-model="model.isAuthorHidden"
                                        :sync="true"
                                        :name="'isAuthorHidden'">
                                    </toggled-btn>
                                </div>

                                <div v-if="hasSecurityCreateRights" class="form-group col-sm-12 col-md-6">
                                    <label class="font-weight-bold">
                                        {{$t('registers.forms.gridHeaders.isFingerprintingDisabled')}}
                                    </label>
                                    <toggled-btn v-model="model.isFingerprintingDisabled"
                                        :sync="true"
                                        :name="'isFingerprintingDisabled'">
                                    </toggled-btn>
                                </div>
                            </div>


                            <div class="form-group" v-if="!model.isAnonymous">
                                <label class="font-weight-bold" :for="'firstName' + _uid">
                                    {{$t('registers.forms.gridHeaders.participationType')}}
                                </label>
                                <DynamicMultiSelect :apiUrl="'/api/participationType/getDropdownModels'"
                                                    v-model="model.participationTypes"
                                                    :id="'participationType' + _uid"
                                                    :name="'participationType' + _uid"
                                                    :filter="'contains'"
                                                    :autoWidth="true"
                                                    :bindPopup="true"
                                                    :popupContainerId="'#' + conatinerId"
                                                    aria-describedby="participationTypeHelp">
                                </DynamicMultiSelect>
                                <div class="text-info radio-message mt-2" id="participationTypeHelp">
                                    <i class="fa fa-exclamation-circle"></i>
                                    {{ $t("registers.forms.editor.helps.participationType") + ' ' + $t("registers.forms.editor.helps.participationType1") }}
                                </div>
                            </div>

                            <div class="form-group">
                                <hr />
                                <div>
                                    <DateTimeRange ref="formToEventAddDateTimeRange"
                                                   :required="true"
                                                   :startTime.sync="model.startTime"
                                                   :endTime.sync="model.endTime"
                                                   :format="dateTimeRangeFormat"
                                                   :showTime="true"
                                                   :startTitle="'registers.events.gridHeaders.eventSubscriptionStartDate'"
                                                   :endTitle="'registers.events.gridHeaders.eventSubscriptionEndDate'"
                                                   :bindPopup="true"
                                                   :popupContainerId="'#' + conatinerId">
                                    </DateTimeRange>
                                </div>
                                <div>
                                    <button type="button" class="btn btn-secondary" aria-describedby="eventSubscriptionStartDateHelp"
                                            @click.stop="setDefaultDates">
                                        <i class="far fa-clone"></i>
                                        {{$t('editor.common.defaultValue')}}
                                    </button>
                                    <small id="eventSubscriptionStartDateHelp" class="form-text text-muted">{{ $t('registers.events.help.eventSubscriptionStartDate') }}</small>
                                </div>
                                <hr />
                            </div>

<!--                            <div class="form-group">
                                <label class="font-weight-bold">
                                    {{$t('registers.forms.gridHeaders.isPopulatingRequired')}}
                                </label>
                                <toggle v-model="model.isPopulatingRequired"></toggle>
                            </div>-->

                            <div v-if="!isInEventActiveRange">
                                <span class="text-warning">
                                    {{ $t('registers.events.errors.outOfEventDateRange')}}
                                </span>
                            </div>
                            <div v-if="!isInEventSubscriptionRange">
                                <span class="text-warning">
                                    {{ $t('registers.events.errors.outOfEventSubscriptionDateRange')}}
                                </span>
                            </div>

                            <div class="text-right mt-3">
                                <div class="btn-group" role="group" aria-label="Form to Event buttons">
                                    <button type="button" class="btn btn-success" @click.stop="onSave"><i class="fas fa-save mr-2"></i>{{ $t('buttons.save.btnText')}}</button>
                                    <button type="button" class="btn btn-danger" @click.stop="onCancel"><i class="fas fa-ban mr-2"></i>{{ $t('buttons.cancel')}}</button>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { FormToEven, EventDetails } from '@/models/models';
    import DateTimeRange from '@/components/dateTimeRange/DateTimeRange_new'
    import DynamicMultiSelect from '@/components/dropdown/DynamicMultiSelect'
    import ToggledBtn from '@/components/toggle/Toggle';
    import eventService from '@/services/event.service';
    import formSurverService from '@/services/formSurvey.service';
    import { mapGetters } from 'vuex';

    export default {
        components: {
            DateTimeRange,
            DynamicMultiSelect,
            ToggledBtn
        },
        props: {
            show: {
                type: Boolean,
                default: false
            },
            eventId: {
                type: Number,
                rquired: true,
            },
        },
        data() {
            return {
                model: new FormToEven(),
                eventDetails: new EventDetails(),
                isSaving: false,
                formType: '',
                formTypeEn: '',
                formAnonymousFillingAllowed: false,
                templatesTransportSettings: {
                    read: {
                        url: this.$store.getters.baseUrl + `/api/dynamicForms/getFormTemplates`,
                        dataType: 'json',
                        type: 'GET',
                        contentType: 'application/json',
                        beforeSend: this.beforeSend
                    },
                },
                templatesFields: {
                    id: { name: 'id', from: 'id', type: 'number', nullable: false },
                    formToRegisterEntityId: { name: 'formToRegisterEntityId', from: 'formToRegisterEntityId', type: 'number', nullable: true },
                    name: { name: 'name', from: 'name', type: 'string', nullable: true },
                    nameEn: { name: 'nameEn', from: 'nameEn', type: 'string', nullable: true },
                    formType: { name: 'formType', from: 'formType', type: 'string', nullable: true },
                    formTypeEn: { name: 'formTypeEn', from: 'formTypeEn', type: 'string', nullable: true },
                    eventName: { name: 'eventName', from: 'eventName', type: 'string', nullable: true }
                },
                footerTemplate: "Total <strong>#: instance.dataSource.total() #</strong> items found",
                conatinerId: 'form-create-container',
                popup: {
                    appendTo: $("#" + this.conatinerId)
                }
            };
        },
        methods: {
            beforeSend: function (req) {
                if (this.token) {
                    req.setRequestHeader('Authorization', 'Bearer ' + this.token);
                }
            },
            dataSourceError(e) {
                this.$vs.notify({
                    title: this.$t('notifications.error'),
                    text: this.$helpers.kendoDataSourceErrorText(e),
                    color: 'danger',
                    time: this.$store.getters.notificationDuration,
                });
            },
            loadEventDetails(eventId) {
                return new Promise((resolve, reject) => {
                    eventService
                        .getDetails(eventId)
                        .then(response => {
                            if (response.data) {
                                this.eventDetails = new EventDetails(response.data);

                                resolve(true);
                            } else {
                                this.$vs.notify({
                                    title: this.$t('request.response.status.' + this.$helpers.responseStatusCode(response)),
                                    text: this.$helpers.responseMessage(response),
                                    color: 'warning',
                                    time: this.$store.getters.notificationDuration
                                });
                            }
                        })
                        .catch(error => {
                            this.$vs.notify({
                                title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                                text: this.$helpers.errorText(error),
                                color: this.$helpers.errorColor(error),
                                time: this.$store.getters.notificationDuration
                            })

                            reject(error);
                        });
                });
            },
            onClose() {
                this.$emit('onClose');
                this.model = new FormToEven();
                this.eventDetails = new EventDetails();
                this.isSaving = false;
                this.$validator.reset();
            },
            hide() {
                $(this.$el).modal('hide');
            },
            onSave(e) {
                e.preventDefault();

                this.$validator.validateAll().then(result => {
                    if (result) {
                        this.validateUniqueFormName()
                            .then(data => {
                                if (data.isValid) {
                                    let msg = `<b>${this.warningMessage}</b>`;
                                    msg += `</br>${this.$t('registers.forms.confirmations.edit')}`

                                    kendo.confirm(msg)
                                        .then(function () {
                                            this.doSave();
                                        }.bind(this));
                                } else {
                                    let msg = data.message;
                                    msg += `</br>${this.$t('registers.forms.formToEvent.warnings.useUniqueFormName')}`
                                    kendo.alert(msg);
                                }
                            })
                            .catch(error => { });
                    }
                });
            },
            doSave() {
                this.isSaving = true;

                formSurverService
                    .addToEvent(this.model)
                    .then(response => {
                        this.$vs.notify({
                            title: this.$t('request.response.status.' + this.$helpers.responseStatusCode(response)),
                            text: this.$helpers.responseMessage(response),
                            color: 'success',
                            time: this.$store.getters.notificationDuration
                        });

                        this.$emit('onCreate', this.model);
                    })
                    .catch(error => {
                        this.$vs.notify({
                            title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                            text: this.$helpers.errorText(error),
                            color: this.$helpers.errorColor(error),
                            time: this.$store.getters.notificationDuration
                        })
                    })
                    .then(() => {
                        this.onClose();
                    });
            },
            onCancel() {
                this.onClose();
            },
            formTemplateSelected(e) {
                if (!e.dataItem) {
                    this.formType = '';
                    this.formTypeEn = '';
                    this.formAnonymousFillingAllowed = false;
                    return;
                }

                this.formType = e.dataItem.formType;
                this.formTypeEn = e.dataItem.formTypeEn;
                this.formAnonymousFillingAllowed = e.dataItem.anonymousFillingAllowed;
            },
            validateUniqueFormName() {
                return new Promise((resolve, reject) => {
                    formSurverService
                        .validateUniqueFormName(this.model)
                        .then(response => {
                            resolve(response.data);
                        })
                        .catch(error => {
                            reject(error);
                        });
                });
            },
            setDefaultDates() {
                if (this.eventDetails) {
                    if (this.eventDetails.eventSubscriptionStartDate) {
                        this.model.startTime = this.eventDetails.eventSubscriptionStartDate;
                    }

                    if (this.eventDetails.eventSubscriptionEndDate) {
                        this.model.endTime = this.eventDetails.eventSubscriptionEndDate;
                    }
                }
            }
        },
        mounted() {
            $(this.$el).on('hidden.bs.modal', this.onClose);
        },
        beforeDestroy() {
            $(this.$el).off('hidden.bs.modal');
        },
        computed: {
            ...mapGetters(['dateTimeFormat', 'dateFormat', 'participationRequestNameEn', 'isEnVersion', 'dropdownHeight', 'claims']),
            token: function () {
                return this.$store.getters.authToken;
            },
            hasSecurityCreateRights() {
                return this.claims.formSecurity.create;
            },
            dateTimeRangeFormat() {
                return this.dateTimeFormat;
            },
            checkEventTimeRangeOnFormAddToEvent() {
                return this.eventDetails && this.eventDetails.appEventSettings
                    && this.eventDetails.appEventSettings.checkEventTimeRangeOnFormAddToEvent === true;
            },
            checkEventSubscriptionTimeRangeOnFormAddToEvent() {
                return this.eventDetails && this.eventDetails.appEventSettings
                    && this.eventDetails.appEventSettings.checkEventSubscriptionTimeRangeOnFormAddToEvent === true;
            },
            isParticipationRequestForm() {
                return this.model.formTypeEn === this.participationRequestNameEn
            },
            isInEventActiveRange() {
                if (!this.checkEventTimeRangeOnFormAddToEvent) {
                    return true;
                }

                if (!this.model.startTime || !this.model.endTime
                    || !this.eventDetails.eventStartDate
                    || !this.eventDetails.eventEndDate) {
                    return true
                }

                const modelStart = this.model.startTime;
                const modelEnd = this.model.endTime;
                const eventStart = new Date(this.eventDetails.eventStartDate);
                const eventEnd = new Date(this.eventDetails.eventEndDate);

                return modelStart >= eventStart && modelEnd <= eventEnd;
            },
            isInEventSubscriptionRange() {
                if (!this.checkEventSubscriptionTimeRangeOnFormAddToEvent) {
                    return true;
                }

                if (!this.model.startTime || !this.model.endTime
                    || !this.eventDetails.eventSubscriptionStartDate
                    || !this.eventDetails.eventSubscriptionEndDate) {
                    return true
                }

                const modelStart = this.model.startTime;
                const modelEnd = this.model.endTime;
                const eventSubscriptionStart = new Date(this.eventDetails.eventSubscriptionStartDate);
                const eventSubscriptionEnd = new Date(this.eventDetails.eventSubscriptionEndDate);

                return modelStart >= eventSubscriptionStart && modelEnd <= eventSubscriptionEnd;
            },
            warningMessage() {
                let msg = '';
                if (!this.isInEventActiveRange) {
                    msg += `${this.$t('registers.events.errors.outOfEventDateRange')}</br>`
                }
                if (!this.isInEventSubscriptionRange) {
                    msg += `${this.$t('registers.events.errors.outOfEventSubscriptionDateRange')}</br>`
                }

                return msg;
            }
        },
        watch: {
            show: function (val) {
                if (val) {
                    this.model = new FormToEven({ eventId: this.eventId });
                    this.loadEventDetails(this.eventId)
                        .then(data => {
                            this.setDefaultDates();
                            $(this.$el).modal('show');
                        })
                        .catch(error => { });
                } else {
                    $(this.$el).modal('hide');
                }
            }
        }
    };
</script>

<style lang="scss" scoped>
    .bmd-form-group {
        padding-top: 0px !important;
    }
</style>
